export const FREE_TRIAL_NOTE =
  'We will verify your payment method, but you will not be charged until after your free trial ends.';
